import {
  getPieceTypeDisplayName,
  type PromotablePieceType,
} from "@cloudnest/augmented-chess-engine";

const PROMOTION_CHOICES: { type: PromotablePieceType; symbol: string }[] = [
  { type: "QUEEN", symbol: "\u265B" },
  { type: "ROOK", symbol: "\u265C" },
  { type: "BISHOP", symbol: "\u265D" },
  { type: "KNIGHT", symbol: "\u265E" },
];

interface PromotionDialogProps {
  onSelectPiece: (pieceType: PromotablePieceType) => void;
  onCancel: () => void;
}

export function PromotionDialog({
  onSelectPiece,
  onCancel,
}: PromotionDialogProps): JSX.Element {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="rounded-xl bg-white p-6 text-center text-gray-900 shadow-2xl">
        <h3 className="mb-4 font-semibold text-lg">
          {"\uC2B9\uC9C4\uD560 \uAE30\uBB3C \uC120\uD0DD"}
        </h3>
        <div className="flex gap-3">
          {PROMOTION_CHOICES.map(({ type, symbol }) => (
            <button
              key={type}
              type="button"
              onClick={() => onSelectPiece(type)}
              className="flex h-15 w-15 cursor-pointer items-center justify-center rounded-lg border-2 border-gray-300 bg-gray-100 text-4xl transition-colors hover:bg-gray-200"
              title={getPieceTypeDisplayName(type)}
            >
              {symbol}
            </button>
          ))}
        </div>
        <button
          type="button"
          onClick={onCancel}
          className="mt-4 cursor-pointer rounded border-none bg-gray-300 px-4 py-2 text-sm transition-colors hover:bg-gray-400"
        >
          {"\uCDE8\uC18C"}
        </button>
      </div>
    </div>
  );
}
